jQuery( document ).ready(function() {
  jQuery('#terms_and_conditions').click(function(){
    //If the checkbox is checked.
    if(jQuery(this).is(':checked')){
        //Enable the submit button.
        jQuery('#submit_button').attr("disabled", false);
    } else{
        //If it is not checked, disable the button.
        jQuery('#submit_button').attr("disabled", true);
    }
		});
      
      });